var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vote"},[_c('NavBar'),_c('iframe',{staticClass:"hiscores",attrs:{"src":"https://unadulterated-fort.000webhostapp.com/hiscores/","frameBorder":"0","scrolling":"no"}}),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }